import { ConstellationOneListing } from '@aloft/toolkit-shared';

type FoundListing = {
  status: 'found';
  listing: ConstellationOneListing;
};

type MissingListing = {
  status: 'missing';
};

export type ListingResult = FoundListing | MissingListing;

export const isFoundListing = (listing: ListingResult): listing is FoundListing =>
  listing.status === 'found';
